// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"147f759e","692":"f88c4504","867":"7dc6210c"}[chunkId] + ".chunk.js";
};